<mat-nav-list fxFlex="1 1 auto" class="sidenav-text">
    <a mat-list-item routerLink="/dashboard" routerLinkActive="active">
        <mat-icon matListItemIcon>dashboard</mat-icon>
        <div i18n-matTooltip="@@dashboard">Dashboard</div>
    </a>
    <a mat-list-item routerLink="/new" routerLinkActive="active">
        <mat-icon matListItemIcon>post_add</mat-icon>
        <div i18n-matTooltip="@@newAsset">New Asset</div>
    </a>
    <a mat-list-item routerLink="/assets" routerLinkActive="active">
        <mat-icon matListItemIcon>library_books</mat-icon>
        <div i18n-matTooltip="@@assets">Assets</div>
    </a>
    <a mat-list-item routerLink="/classes" routerLinkActive="active">
        <mat-icon matListItemIcon>class</mat-icon>
        <div i18n-matTooltip="@@classes">Classes</div>
    </a>
    <a mat-list-item routerLink="/places" routerLinkActive="active">
        <mat-icon matListItemIcon>home_work</mat-icon>
        <div i18n-matTooltip="@@places">Places</div>
    </a>
    <a mat-list-item routerLink="/label" routerLinkActive="active">
        <mat-icon matListItemIcon>print</mat-icon>
        <div i18n-matTooltip="@@printLabel">Print Label</div>
    </a>
</mat-nav-list>